import {
  InfoOutlined,
  type SvgIconComponent as MuiSvgIconComponent,
} from '@mui/icons-material';
import { Alert as MuiAlert, AlertTitle } from '@mui/material';
import { SystemColors } from 'melp-design/style';
import { ReactNode } from 'react';

interface Props {
  severity?: 'success' | 'info' | 'warning' | 'error';
  children: ReactNode;
  onClose?: () => void;
  title?: string;
  icon?: MuiSvgIconComponent;
}

const Alert = ({
  severity = 'info',
  title,
  children,
  onClose,
  icon: Icon = InfoOutlined,
}: Props) => {
  return (
    <MuiAlert
      severity={severity}
      icon={<Icon color="inherit" />}
      onClose={onClose}
    >
      {title ? (
        <AlertTitle color={SystemColors.grey[45]}>{title}</AlertTitle>
      ) : null}
      {children}
    </MuiAlert>
  );
};

export default Alert;
